/* Encasa XO customization: spark bursts for the Diwali festive menu link (snippets/festive-nav-link.liquid). */
(() => {
  if (window.__festiveNavInit) return;
  window.__festiveNavInit = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const COLORS = ['#ffd54a', '#ffb020', '#ff8a1f', '#fff3c4', '#f43f5e', '#ffe08a'];
  const MAX_LIVE = 90;
  let live = 0;

  function burst(el, count, power) {
    if (reducedMotion.matches || !el.isConnected) return;
    const rect = el.getBoundingClientRect();
    if (!rect.width || rect.bottom < 0 || rect.top > window.innerHeight) return;

    // Sparks fly from the diya flame
    const diya = el.querySelector('.festive-link__diya');
    const origin = (diya || el).getBoundingClientRect();
    const ox = origin.left + origin.width / 2;
    const oy = origin.top + origin.height * 0.3;

    for (let i = 0; i < count && live < MAX_LIVE; i++) {
      spawn(ox, oy, power);
    }
  }

  function spawn(ox, oy, power) {
    const spark = document.createElement('span');
    spark.className = 'festive-spark';

    const streak = Math.random() < 0.45;
    const size = streak ? 1.6 + Math.random() * 1.2 : 2 + Math.random() * 2.6;
    const length = streak ? size * (3 + Math.random() * 3) : size;
    const color = COLORS[(Math.random() * COLORS.length) | 0];

    spark.style.width = `${length}px`;
    spark.style.height = `${size}px`;
    spark.style.background = color;
    spark.style.boxShadow = `0 0 ${size * 2.5}px ${color}`;

    // Fountain (anar) style: mostly upward fan, with gravity pulling down
    const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.25;
    const speed = (40 + Math.random() * 70) * power;
    const vx = Math.cos(angle) * speed;
    const vy = Math.sin(angle) * speed;
    const gravity = 120 + Math.random() * 60;
    const duration = 700 + Math.random() * 600;

    const steps = 6;
    const frames = [];
    for (let s = 0; s <= steps; s++) {
      const t = (s / steps) * (duration / 1000);
      const x = ox + vx * t;
      const y = oy + vy * t + 0.5 * gravity * t * t;
      const dirX = vx;
      const dirY = vy + gravity * t;
      const rot = Math.atan2(dirY, dirX) * (180 / Math.PI);
      const progress = s / steps;
      frames.push({
        transform: `translate(${x - length / 2}px, ${y - size / 2}px) rotate(${rot}deg) scale(${1 - progress * 0.6})`,
        opacity: progress < 0.15 ? progress / 0.15 : 1 - Math.pow(progress, 1.6),
      });
    }

    document.body.appendChild(spark);
    live++;
    const anim = spark.animate(frames, { duration, easing: 'linear', fill: 'forwards' });
    const done = () => {
      spark.remove();
      live--;
    };
    anim.onfinish = done;
    anim.oncancel = done;
  }

  // Hover / focus bursts (throttled per link)
  const lastBurst = new WeakMap();
  function onEnter(event) {
    const link = event.target.closest && event.target.closest('[data-festive-link]');
    if (!link) return;
    if (event.type === 'pointerover' && event.relatedTarget && link.contains(event.relatedTarget)) return;
    const now = performance.now();
    if (now - (lastBurst.get(link) || 0) < 700) return;
    lastBurst.set(link, now);
    burst(link, 26, 1);
  }

  document.addEventListener('pointerover', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter);

  // Small celebratory burst on tap/click (navigation is not delayed)
  document.addEventListener('pointerdown', (event) => {
    const link = event.target.closest && event.target.closest('[data-festive-link]');
    if (link) burst(link, 34, 1.25);
  }, { passive: true });

  // Ambient: a gentle sparkle every few seconds while the link is visible
  let visible = new Set();
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target);
        });
      })
    : null;

  function observeAll() {
    if (!observer) return;
    visible = new Set();
    observer.disconnect();
    document.querySelectorAll('[data-festive-link]').forEach((el) => observer.observe(el));
  }

  observeAll();
  document.addEventListener('shopify:section:load', observeAll);

  setInterval(() => {
    if (document.hidden) return;
    visible.forEach((el) => {
      if (!el.matches(':hover')) burst(el, 10, 0.75);
    });
  }, 6500);

  // First load: a welcoming burst once the page settles
  window.addEventListener('load', () => {
    setTimeout(() => visible.forEach((el) => burst(el, 22, 1)), 900);
  }, { once: true });
})();
